import { useEffect, useState } from 'react';
import { APP_SHELL_BREAKPOINT, type AppViewportTier } from '@shared/constants';

function readTier(width: number): AppViewportTier {
  if (width < APP_SHELL_BREAKPOINT.mobile) return 'mobile';
  if (width < APP_SHELL_BREAKPOINT.desktop) return 'tabletPortrait';
  return 'desktop';
}

/**
 * Which shell layout the current viewport gets.
 *
 * Three tiers rather than one `isMobile` boolean: a 768px iPad in portrait is
 * neither — it clears the phone breakpoint, so the old boolean handed it the
 * full desktop rail and left 504px for content. Driven by `matchMedia` rather
 * than a `resize` listener so the callback only fires when the tier actually
 * changes, not on every pixel of a window drag.
 */
export function useViewportTier(): AppViewportTier {
  const [tier, setTier] = useState<AppViewportTier>(() =>
    typeof window === 'undefined' ? 'desktop' : readTier(window.innerWidth)
  );

  useEffect(() => {
    const queries = [
      window.matchMedia(`(max-width: ${APP_SHELL_BREAKPOINT.mobile - 1}px)`),
      window.matchMedia(
        `(min-width: ${APP_SHELL_BREAKPOINT.mobile}px) and (max-width: ${APP_SHELL_BREAKPOINT.desktop - 1}px)`
      ),
    ];
    const sync = () => setTier(readTier(window.innerWidth));
    sync();
    queries.forEach((query) => query.addEventListener('change', sync));
    return () => queries.forEach((query) => query.removeEventListener('change', sync));
  }, []);

  return tier;
}
